import { BillStatuses } from "@legacy/core/utils/enums"

import { ObjectsView } from "@organisms"

import { BILLS_ROUTES } from "@routes/bills"

export const BillObjectsViewTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_open"
            phase="open"
            title="All Open"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", BillStatuses.pending],
                ["status", BillStatuses.unpaid],
                ["ordering", "date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="pending"
            phase="open"
            title="Pending"
            endpointKwargs={[
                ["status", BillStatuses.pending],
                ["ordering", "date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="outstanding"
            phase="open"
            title="Outstanding"
            endpointKwargs={[
                ["status", BillStatuses.unpaid],
                ["is_overdue", "false"],
                ["ordering", "date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="overdue"
            phase="open"
            title="Overdue"
            endpointKwargs={[
                ["status", BillStatuses.unpaid],
                ["is_overdue", "true"],
                ["ordering", "date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_closed"
            phase="closed"
            title="All Closed"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", BillStatuses.paid],
                ["status", BillStatuses.voided],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="paid"
            phase="closed"
            title="Paid"
            endpointKwargs={[
                ["status", BillStatuses.paid],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="voided"
            phase="closed"
            title="Voided"
            endpointKwargs={[
                ["status", BillStatuses.voided],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
    </ObjectsView.Tabs>
)
